import { InstituteLogo } from "@/components/InstituteLogo";
import { INSTITUTE_NAME } from "@/lib/branding";
import { getDefaultPlayerLoginUrl } from "@/lib/api";
import { usePlayerAuth } from "@/context/PlayerAuthContext";

interface LoginRequiredProps {
  /** Stronger copy when blocking lesson URLs without a session */
  variant?: "default" | "lesson";
}

export function LoginRequired({ variant = "default" }: LoginRequiredProps) {
  const { loginUrl: ctxUrl } = usePlayerAuth();
  const loginUrl = ctxUrl?.trim() || getDefaultPlayerLoginUrl();

  const copy =
    variant === "lesson"
      ? "You need to be signed in on the course site to view this lesson. Open the course from the community portal after logging in, or use the button below."
      : "Sign in on the course site to use the lesson player and track your progress.";

  return (
    <div className="min-h-full flex flex-col items-center justify-center p-8 lp-theme-adult bg-gradient-to-b from-slate-50 to-indigo-50/40">
      <div className="mb-6 rounded-2xl bg-white p-4 shadow-lg shadow-indigo-100/60 ring-1 ring-slate-100">
        <InstituteLogo height={72} />
      </div>
      <p className="text-xs font-semibold uppercase tracking-widest text-indigo-600/90 mb-2">{INSTITUTE_NAME}</p>
      <h1 className="text-xl font-bold text-slate-800 text-center mb-3" style={{ fontFamily: "var(--lp-font-heading)" }}>
        Please log in
      </h1>
      <p className="text-slate-600 text-center mb-8 max-w-md text-sm">{copy}</p>
      <a
        href={loginUrl}
        className="inline-flex items-center justify-center rounded-full px-8 py-3 text-sm font-semibold text-white shadow-lg bg-gradient-to-r from-indigo-600 to-violet-600 hover:from-indigo-500 hover:to-violet-500 transition-colors"
      >
        Go to student course
      </a>
    </div>
  );
}
